import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  myHeader: {
    '@media print': {
      display: 'none',
    },
    borderTop: '1px solid rgba(255,255,255,0.25)',
    backgroundColor: '#192542',
  },
  content: {
    background: '#f3f3f3',
    minHeight: '100%',
    position: 'relative',
    zIndex: 2,
  },
  container: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    padding: '0 2rem',
    maxWidth: '1440px',
    minHeight: '100%',
    position: 'relative',
    height: 62,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '0 1rem',
    },
  },
  logo: {
    display: 'flex',
    alignItems: 'center',

    '& img': {
      maxWidth: 85,
      marginRight: 8,
    },
  },
}));

const Header = () => {
  const classes = useStyles();

  return (
    <header>
      <div className={'my-header ' + classes.myHeader}>
        <div className={classes.container}>
          <div className={classes.logo}>
            <Link to='/'>
              <img alt='Orbita 2.0' src='/img/logo-orbita-myeduzz.png' />
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
